import axios from 'axios'

const apiClient = axios.create({
    // 相对路径：由阿里云 nginx 的 /api 反向代理到后端（NAS 的 Cornerstone）
    baseURL: '/api',
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
})

export default {
    getResumeData() {
        return apiClient.get('/resume')
    }
}